"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var PlayerTagsListCtl = /** @class */ (function (_super) {
    __extends(PlayerTagsListCtl, _super);
    function PlayerTagsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_usr_player_tag_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_player_tag_title; });
        _this.dk_usr_player_tag_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_player_tag_code; });
        _this.dk_usr_player_tag_color = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_player_tag_color; });
        _this.dk_usr_player_tag_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.usr_player_tag_id; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this._errDialog = errDialog;
        return _this;
    }
    PlayerTagsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    PlayerTagsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "player with id [" + id + "] not found !";
    };
    PlayerTagsListCtl.prototype.LoadData = function (playerId, onDone) {
        var _this = this;
        webAApi_1.ListUserPlayerTagsByUserIdGet.exec({ user_player_id: playerId }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    usr_player_tag_code: resp.list[i].usr_player_tag_code,
                    usr_player_tag_title: resp.list[i].usr_player_tag_title,
                    usr_player_tag_color: resp.list[i].usr_player_tag_color,
                    usr_player_tag_id: resp.list[i].usr_player_tag_id,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayerTagsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddUserPlayerTag.exec({
            user_player_id: data.usr_player_id,
            app_user_player_tag_id: data.app_user_player_tag_id
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_added: moment(resp.date_added_uts_ms).utc(false),
                usr_player_tag_code: resp.app_user_player_tag_code,
                usr_player_tag_title: resp.app_user_player_tag_title,
                usr_player_tag_color: resp.app_user_player_tag_color,
                usr_player_tag_id: data.app_user_player_tag_id
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PlayerTagsListCtl.prototype.RemoveItem = function (accessKey) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === accessKey) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    PlayerTagsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteUserPlayerTag.exec({
                usr_player_tag_id: key,
            }, function (resp) {
                _this.RemoveItem(_tmp.key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return PlayerTagsListCtl;
}(BaseController_1.BaseController));
exports.PlayerTagsListCtl = PlayerTagsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_players_list/ctl/PlayerTagsListCtl.ts
// module id = 924
// module chunks = 0